import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { CampoTablaWhereService } from '@shared/services/campo-tabla-where.service';
import { InjectableService } from '../../utils/injectable.service';

@Component({
  selector: 'app-select-moneda',
  templateUrl: './select-moneda.component.html',
  styleUrls: ['./select-moneda.component.css'],
})
export class SelectMonedaComponent implements OnInit {
  public columns: string[] = ['actions', 'descripcion'];

  public allData: number = 0;
  public loading: boolean = true;

  constructor(
    private _ctwServices: CampoTablaWhereService,
    private _injectServices: InjectableService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  dataSource = new MatTableDataSource();

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  read() {
    this._ctwServices.monedas().subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      if (this.allData >= 0) this.loading = false;
    });
  }

  injectData(data: string) {
    const model = {
      data: data,
      success: true,
    };
    this._injectServices.disparadorMoneda.emit({ model });
  }
}
